import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { CostSection } from './components/CostSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { StickyCta } from './components/StickyCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-ink-900 font-sans antialiased" data-id="element-0" data-mp="28te0v7ntuzkg">
      <Hero data-id="element-1" data-mp="23vchsmqej08z" />
      <main data-id="element-2" data-mp="23vuo6c6s2uum">
        <PainSection data-id="element-3" data-mp="23w4drynwuzzs" />
        <TomosSection data-id="element-4" data-mp="23ujha3i1d6za" />
        <BonusSection data-id="element-5" data-mp="23t8fuac2cbbc" />
        <PricingSection data-id="element-6" data-mp="3ijxsv0nzqion" />
        <CostSection data-id="element-7" data-mp="3ikqz80j1f669" />
        <TestimonialsSection data-id="element-8" data-mp="3ijfwm41bw4gq" />
        <GuaranteeSection data-id="element-9" data-mp="3ii4sg33z0up3" />
        <FaqSection data-id="element-10" data-mp="3ml14faz09sk2" />
        <FinalCta data-id="element-11" data-mp="3mkhn9wh6j873" />
      </main>
      <Footer data-id="element-12" data-mp="3mjq45l4rr2xp" />
      <StickyCta data-id="element-13" data-mp="3mj6jvxrnc2gi" />
    </div>;
}